<template>
  <div>
    <v-progress-linear :indeterminate="loadingCaseForms" v-if="loadingCaseForms"></v-progress-linear>
    <v-form v-model="valid" v-if="!loadingCaseForms">
      <v-layout row wrap>
        <v-flex xs4>
          <v-subheader class="required">Date:</v-subheader>
        </v-flex>

        <v-flex xs8>
          <v-menu>
            <v-text-field
              v-model="localMainForm.deceased_date"
              slot="activator"
              readonly
              :rules="dateRules"
            ></v-text-field>
            <v-date-picker v-model="localMainForm.deceased_date" reactive></v-date-picker>
          </v-menu>
        </v-flex>

        <v-flex xs4>
          <v-subheader class="required">Deceased Name:</v-subheader>
        </v-flex>

        <v-flex xs8>
          <v-text-field v-model="localMainForm.deceased_name" :rules="deceasedNameRules"></v-text-field>
        </v-flex>

        <v-flex xs4>
          <v-subheader class="required">Gender:</v-subheader>
        </v-flex>

        <v-flex xs8>
          <v-select v-model="localMainForm.deceased_gender" :items="['M', 'F']" :rules="genderRules"></v-select>
        </v-flex>

        <v-flex xs4>
          <v-subheader>中⽂姓名:</v-subheader>
        </v-flex>

        <v-flex xs8>
          <v-text-field v-model="localMainForm.deceased_name_chinese"></v-text-field>
        </v-flex>

        <v-flex xs4>
          <v-subheader class="required">Age:</v-subheader>
        </v-flex>

        <v-flex xs8>
          <v-text-field v-model="localMainForm.deceased_age" type="number" :rules="ageRules"></v-text-field>
        </v-flex>

        <v-flex xs4>
          <v-subheader>Death Certificate No:</v-subheader>
        </v-flex>

        <v-flex xs8>
          <v-text-field v-model="localMainForm.deceased_death_certificate_no"></v-text-field>
        </v-flex>

        <v-flex xs4>
          <v-subheader class="required">Religion:</v-subheader>
        </v-flex>

        <v-flex xs8>
          <v-select v-model="localMainForm.deceased_religion" :items="[
            'Buddhist',
            'Taoist',
            'Catholic',
            'Christian',
            'Free thinker',
            'Hindu',
            'Soka',
            'Others'
          ]" :rules="religionRules"></v-select>
        </v-flex>

        <v-flex xs4>
          <v-subheader class="required">Dialect:</v-subheader>
        </v-flex>

        <v-flex xs8>
          <v-select v-model="localMainForm.deceased_dialect" :items="[
            'Hokkien',
            'Teochew',
            'Cantonese',
            'Hainanese',
            'Hakka',
            'Shanghainese',
            'Hokchew',
            'Others'
          ]" :rules="dialectRules"></v-select>
        </v-flex>

        <v-flex xs4>
          <v-subheader class="required">Location of Wake:</v-subheader>
        </v-flex>

        <v-flex xs8>
          <v-text-field v-model="localMainForm.deceased_location_of_wake" :rules="locationOfWakeRules"></v-text-field>
        </v-flex>

        <v-flex xs4>
          <v-subheader class="required">Crematorium / Burial Location:</v-subheader>
        </v-flex>

        <v-flex xs8>
          <v-select
            :items="burialLocations"
            v-model="localMainForm.deceased_burial_location"
            :rules="burialLocationsRules"
          ></v-select>
        </v-flex>

        <v-flex xs4>
          <v-subheader>Embalming:</v-subheader>
        </v-flex>

        <v-flex xs8>
          <v-checkbox
            v-model="localMainForm.deceased_embalming"
          ></v-checkbox>
        </v-flex>
      </v-layout>
    </v-form>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      caseid: {
        type: Number,
        required: true
      }
    },
    computed: {
      ...mapGetters({
        formData: 'getOnBoardClientFormAnswers',
        editable: 'isOnBoardClientFormAnswersEditable',
        loadingCaseForms: 'getLoadingFormsStatus'
      })
    },
    watch: {
      valid (newVal) {
        this.$store.commit('updateMainOnBoardForm', this.localMainForm)
        this.$emit('valid:changed', newVal)
      },
      formData () {
        this.caseSelected = this.caseid
        this.localMainForm = this.formData.main_form
      }
    },
    data () {
      return {
        localMainForm: {},
        valid: false,
        caseSelected: null,
        items: [],
        dateRules: [
          v => !!v || 'Required'
        ],
        deceasedNameRules: [
          v => !!v || 'Required'
        ],
        genderRules: [
          v => !!v || 'Required'
        ],
        ageRules: [
          v => v >= 0 && v <= 120 || 'Age can be from 1 to 120',
          v => !!v || 'Required'
        ],
        deathCertificateNoRules: [
          v => !!v || 'Required'
        ],
        religionRules: [
          v => !!v || 'Required'
        ],
        dialectRules: [
          v => !!v || 'Required'
        ],
        locationOfWakeRules: [
          v => !!v || 'Required'
        ],
        burialLocationsRules: [
          v => !!v || 'Required'
        ],
        burialLocations: [
          'MC', 'KMS', 'TTA', 'Lim Chu Kang'
        ]
      }
    },
    created () {
      // this[_.camelCase(item.input_id)] = item.answer
      // s.split(/(?=[A-Z])/).join('_').toLowerCase()
      this.localMainForm = this.formData.main_form
    }
  }
</script>



// WEBPACK FOOTER //
// Forms.vue?4e7ee3ae